import React from 'react';
import styles from 'styles/components/question-builders/ExistingSurveysList.module.css';
import _ from 'lodash';
import { ActionButton } from '@ax2/common/components/ActionButton';
import UUID from '@ax2/common/model/UUID';
import SurveySchema from '@ax2/common/model/schemas/SurveySchema';
import { ExpandableQuestionsFlow } from 'components/expandable/ExpandableQuestionsFlow';
import { SurveyPurposeElement } from '../SurveyPurposeElement';
import { getMockedSurveyTemplates } from 'rest/mockedDataClient';
import PanelType from '@ax2/common/model/PanelType';

export interface TemplateSurveysListData {
  panel: PanelType;
  specialty?: number;
  onSelect: (surveyId: UUID) => void;
}
export const TemplateSurveysList: React.FC<TemplateSurveysListData> = props => {
  const [surveys, setSurveys] = React.useState<SurveySchema[]>();
  React.useEffect(() => {
    //Change to template lib
    async function fetchData() {
      const data = await getMockedSurveyTemplates();
      const [physicianTemplates, otherTemplates] = _.partition(
        data,
        s => s.panel === PanelType.PhysicianSurvey
      );
      const ts =
        props.panel === PanelType.PhysicianSurvey
          ? physicianTemplates
          : otherTemplates;
      const templates = _.map(ts, d => ({ ...d, panel: props.panel })); // TODO: remove this field override after server interration
      setSurveys(templates);
    }
    fetchData();
  }, [props.panel]);
  return (
    <div>
      <div className={styles.listHeader}>
        <span>Choose A Survey Template</span>
      </div>
      {_.map(surveys, (survey, index) => (
        <div className={styles.surveyWrapper} key={index}>
          <ExpandableQuestionsFlow
            id={'tsl-survey-' + (index + 1)}
            title={survey.title ? survey.title : 'Not specified'}
            subtitle="Editable"
            expandLabel="Preview this template"
            previewContent={
              <SurveyPurposeElement
                title="Busines need"
                text={survey.title ? survey.title : ''}
              />
            }
            actionElement={
              <ActionButton
                text="Use this template"
                type="primary"
                onClick={() => {
                  props.onSelect(survey.id);
                }}
              />
            }
            screeners={survey.screeners}
            questions={survey.questions}
          />
        </div>
      ))}
    </div>
  );
};
